<script>
    import Vue from 'vue';
    import Chrome from "vue-color/src/components/Chrome";

    export default {
        components: {
            'chrome-picker': Chrome,
        },
        template: `
            <div class="color-picker form-material form-group" ref="colorpicker">
            <label v-if="name" label class="control-label">{{$t('input.color')}}</label>
                <input type="text" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" style="display: none" />
                <span class="color-picker-container">
                    <span :class="name ? 'current-color margin-top' : 'current-color'" :style="'background-color: ' + colorValue" @click="togglePicker()"></span>
                    <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker" />
                </span>
            </div>`,
        props: ['color', 'name', 'enableColor'],
        data() {
            return {
                colors: {
                    hex: this.name ? '#000000' : '#D7092E',
                },
                colorValue: '',
                displayPicker: false,
            }
        },
        mounted() {
          const color = this.name ? '#000000' : '#D7092E';
          this.setColor(this.color || color);
        },
        methods: {
            setColor(color) {
                this.updateColors(color);
                this.colorValue = color;
            },
            updateColors(color) {
                if(color.slice(0, 1) == '#') {
                    this.colors = {
                        hex: color
                    };
                }
                else if(color.slice(0, 4) == 'rgba') {
                    var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
                        hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
                    this.colors = {
                        hex: hex,
                        a: rgba[3],
                    }
                }
            },
            showPicker() {
                document.addEventListener('click', this.documentClick);
                this.displayPicker = true;
            },
            hidePicker() {
                document.removeEventListener('click', this.documentClick);
                this.displayPicker = false;
            },
            togglePicker() {
                this.displayPicker ? this.hidePicker() : this.showPicker();
            },
            updateFromInput() {
                this.updateColors(this.colorValue);
            },
            updateFromPicker(color) {
                this.colors = color;
                if(color.rgba.a == 1) {
                    this.colorValue = color.hex;
                }
                else {
                    this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
                }
            },
            documentClick(e) {
                var el = this.$refs.colorpicker,
                    target = e.target;
                if(el !== target && !el.contains(target)) {
                    this.hidePicker()
                }
            }
        },
        watch: {
          enableColor(newVal, oldVal) {
            if (newVal && typeof oldVal !== 'undefined') {
              this.$emit('updateCurrentColor', this.colorValue);
            }
          },
            colorValue(val, old) {
                if(val) {
                    this.updateColors(val);
                    this.$emit('input', val);
                }
            },
            color: function(newVal, oldVal) { // watch it
                if(newVal) {
                    this.updateColors(newVal);
                    this.colorValue = newVal;
                    this.$emit('input', newVal);
                }
            }
        },
    };
</script>
<style>
    h1 {
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .vc-chrome {
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 999;
    }
    .current-color {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: #000;
        cursor: pointer;
    }
    .margin-top {
      margin-top: 10px;
    }

</style>



// WEBPACK FOOTER //
// Colorpicker.vue?6c62dc95